import React from "react";

import { ButtonLoading, ButtonStandard, ModalBase, Text } from "@performyard/py-components";

import { useMutateGoalDetails } from "../../../../api/hooks";

type GoalReopenModalProps = {
	goalId?: string;
	goalName?: string;
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
};

const GoalReopenModal = ({
	goalId,
	goalName,
	isOpen,
	onClose,
	onSuccess,
}: GoalReopenModalProps): React.ReactElement => {
	const { mutate, isPending } = useMutateGoalDetails(goalId || "", {
		onSuccess: () => {
			onSuccess?.();
			onClose();
		},
	});

	const handleReopen = (): void => {
		if (!goalId) {
			return;
		}
		mutate([{ field: "status", value: "active" }]);
	};

	return (
		<ModalBase isOpen={isOpen} onClose={onClose} dangerouslySetClassName="w-[432px]">
			<div className="px-6 pb-4 text-center">
				<Text size="sub-heading" weight="semi-bold">
					Reopen Goal?
				</Text>
				{goalName ? (
					<Text size="paragraph-2" weight="regular">
						{goalName}
					</Text>
				) : null}
			</div>

			<div className="px-6 pb-6 text-center">
				<Text size="paragraph-2" weight="semi-bold">
					Are you sure you want to reopen this goal?
				</Text>
			</div>

			<div className="flex justify-center gap-2 px-6 pb-6">
				<div className="w-fit min-w-[90px]">
					<ButtonStandard
						variant="outline"
						color="neutral"
						size="large"
						onClick={onClose}
						disabled={isPending}
						data-testid="cancel-reopen-goal"
					>
						Cancel
					</ButtonStandard>
				</div>
				<div className="w-[120px]">
					<ButtonLoading
						color="primary"
						size="large"
						loading={isPending}
						disabled={!goalId || isPending}
						onClick={handleReopen}
						data-testid="reopen-goal"
					>
						Yes, Reopen
					</ButtonLoading>
				</div>
			</div>
		</ModalBase>
	);
};

export default GoalReopenModal;
